/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 * @enum {string}
 */
export enum EdiDeliveryProtocol {
  Sftp = "sftp",
  Ftp = "ftp",
  Ftps = "ftps",
}

export function instanceOfEdiDeliveryProtocol(value: any): boolean {
  for (const key in EdiDeliveryProtocol) {
    if (Object.prototype.hasOwnProperty.call(EdiDeliveryProtocol, key)) {
      if (
        EdiDeliveryProtocol[key as keyof typeof EdiDeliveryProtocol] === value
      ) {
        return true;
      }
    }
  }
  return false;
}

export function EdiDeliveryProtocolFromJSON(json: any): EdiDeliveryProtocol {
  return EdiDeliveryProtocolFromJSONTyped(json, false);
}

export function EdiDeliveryProtocolFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): EdiDeliveryProtocol {
  return json as EdiDeliveryProtocol;
}

export function EdiDeliveryProtocolToJSON(
  value?: EdiDeliveryProtocol | null,
): any {
  return value as any;
}

export function EdiDeliveryProtocolToJSONTyped(
  value: any,
  ignoreDiscriminator: boolean,
): EdiDeliveryProtocol {
  return value as EdiDeliveryProtocol;
}
